import { AxiosResponse } from 'axios'
import { http } from '@/core/realisations/Http.realisation'

const GEOCODER_LANG = process.env.VUE_APP_MAP_LANG!

const YANDEX_GEOCODER_URL = process.env.VUE_APP_YANDEX_GEOCODER_URL!
const YANDEX_GEOCODER_KEY = process.env.VUE_APP_YANDEX_GEOCODER_KEY!

const TWOGIS_GEOCODER_URL = process.env.VUE_APP_TWOGIS_GEOCODER_URL!
const TWOGIS_GEOCODER_KEY = process.env.VUE_APP_TWOGIS_GEOCODER_KEY!

import { YandexGeocodeResponseT, TwoGisGeocodeResponseT, YandexGeocodeParams, YandexGeocodeOptions } from '@/core/types/geocoder.types'

export class GeocoderRepository {
    geocode(options: YandexGeocodeOptions): Promise<AxiosResponse<YandexGeocodeResponseT>> {
        const params: YandexGeocodeParams = {
            apikey: YANDEX_GEOCODER_KEY,
            lang: 'ru_RU',
            format: 'json',
            geocode: options.geocode,
            kind: options.kind,
            results: options.results,
            ll: options.ll,
            spn: options.spn,
            skip: options.skip,
        }
    
        if (options.bbox) {
            params.bbox = `${options.bbox[0][1]},${options.bbox[0][0]}~${options.bbox[1][1]},${options.bbox[1][0]}`
            params.rspn = 1
        }
    

        return http.get(YANDEX_GEOCODER_URL, { params })
    }

    yandexGeocode(geocode: string, bbox: number[][] | null): Promise<AxiosResponse<YandexGeocodeResponseT>> {
        const params = {
            apikey: YANDEX_GEOCODER_KEY,
            lang: GEOCODER_LANG,
            format: 'json',
            geocode,
            bbox: undefined as string | undefined,
            rspn: 0
        }

        if (bbox) {
            params.bbox = `${bbox[0][1]},${bbox[0][0]}~${bbox[1][1]},${bbox[1][0]}`
            params.rspn = 1
        }

        return http.get(YANDEX_GEOCODER_URL, { params })
    }

    twoGisGeocodeByCoords(coordinates: number[]): Promise<AxiosResponse<TwoGisGeocodeResponseT>> {
        const params = {
            lat: coordinates[0],
            lon: coordinates[1],
            key: TWOGIS_GEOCODER_KEY,
            fields: 'items.point,items.adm_div,items.full_address_name',
        }

        return http.get(TWOGIS_GEOCODER_URL, { params })
    }

    twoGisGeocodeByAddress(address: string, coordinates: number[][] | null): Promise<AxiosResponse<TwoGisGeocodeResponseT>> {
        const params = {
            q: address,
            key: TWOGIS_GEOCODER_KEY,
            fields: 'items.point,items.adm_div,items.full_address_name',
            point1: undefined as string | undefined,
            point2: undefined as string | undefined
        }

        if (coordinates) {
            params.point1 = `${coordinates[0][1]},${coordinates[0][0]}`
            params.point2 = `${coordinates[1][1]},${coordinates[1][0]}`
        }

        return http.get(TWOGIS_GEOCODER_URL, { params })
    }
}
